/** What a notebook's page, a notepad's or an agenda's, is filled with (see
 * PlotNotebookBackground): nothing, lines, lines of dots, a grid of dots, of
 * squares, or a millimetre paper's. */
export const enum NotebookBackground {
  BLANK = "blank",
  LINES = "lines",
  DOTTED_LINES = "dotted_lines",
  DOTS = "dots",
  SQUARES = "squares",
  MILLIMETER = "millimeter",
}
